import { NgModule } from '@angular/core'
import { NoPreloading, RouterModule, Routes, UrlMatcher, UrlSegment } from '@angular/router'

// Matches `/app-token` and `/app-token/{token}`. The token is a Cry-encrypted
// base64 string that may contain `/`, so a plain `:token` param would break.
// The matcher reassembles every segment after `app-token` with `/` so both
// `/app-token/abc%2Fdef` (encoded) and `/app-token/abc/def` (raw) resolve to
// the same token value. `/app-token` with no token yields an empty string,
// which the component surfaces as an error.
export const appTokenMatcher: UrlMatcher = (segments: UrlSegment[]) => {
  if (!segments.length || segments[0].path !== 'app-token') return null
  const token = segments.slice(1).map(s => s.path).join('/')
  return { consumed: segments, posParams: { token: new UrlSegment(token, {}) } }
}

const routes: Routes = [
  // app-token: landing page for custom-token deep-link authentication (embed partners)
  { matcher: appTokenMatcher, loadComponent: () => import('./components/app-token/app-token.component').then(m => m.AppTokenComponent) },

  { path: '', loadChildren: () => import('./main/main.module').then(m => m.MainModule) },

  // the login module is lazy loaded outside the main module, this way we have the first load only
  // of Angular bootstrap and the login screen, only going to main lazily, after being authenticated
  { path: 'login', loadChildren: () => import('@user/user.module').then(m => m.UserModule) },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
    preloadingStrategy: NoPreloading,
    // relativeLinkResolution: 'legacy',
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 80]
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
